// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  AckNotificationRequestSchema,
} from "../../generated/wisetime/user/notification/v4/notification_pb"
import {
  ListUserTimelineMessagesRequestSchema
} from "../../generated/wisetime/user/timelinemessage/v4/user_timeline_message_pb"
import { GetTeamRequest } from "../../generated/wt/svc/customer/user_team_pb"
import type { MessageInitShape as Init } from "@bufbuild/protobuf"

export const currentSiteIdPersisted = createAction("user-context/current-site-id-persisted")
export const currentSiteIdPersistFailed = createAction("user-context/current-site-id-persist-failed")

export const fetchUserDetails = createAction("user-context/fetch-user-details")
export const fetchUserDetailsFailed = createAction("user-context/fetch-user-details-failed")

export const refreshSiteDetails = createAction<{ siteId: string }>("user-context/refresh-site-details")

export const getSiteFailed = createAction("user-context/get-site-failed")
export const listSitePermissionsFailed = createAction("user-context/list-site-permissions-failed")
export const loadCurrentSiteIdFailed = createAction("user-context/load-current-site-id-failed")

export const logOut = createAction("user-context/log-out")
export const logOutDone = createAction("user-context/log-out-done")

export const redirectToAddTeam = createAction("user-context/redirect-to-add-team")
export const redirectToAddTeamDone = createAction("user-context/redirect-to-add-team-done")

export const listNotifications = createAction("user-context/list-notifications")
export const listNotificationsFailed = createAction("user-context/list-notifications-failed")

export const ackNotification = createAction<Init<typeof AckNotificationRequestSchema>>("user-context/ack-notification")
export const ackNotificationFailed = createAction("user-context/ack-notification-failed")

export const redirectToUrl = createAction<string>("user-context/redirect-to-url")
export const redirectToUrlDone = createAction("user-context/redirect-to-url-done")

export const listUserTimelineMessages = createAction<Init<typeof ListUserTimelineMessagesRequestSchema>>("user-context/list-user-timeline-messages")
export const listUserTimelineMessagesFailed = createAction("user-context/list-user-timeline-messages-failed")

export const getTeam = createAction<GetTeamRequest>("user-context/get-team")
export const getTeamFailed = createAction("user-context/get-team-failed")
